/** @format */

import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";

const UpdatedStudent = ({
  firstName,
  lastName,
  otherName,
  email,
  age,
  selectClass,
  handleDeleteDoc,
  handleEditDoc,
  url,
  id,
}) => {
  const [showList, setShowList] = useState(false);
  const { handleShowProfile } = useAuth();

  const handleShowList = () => {
    setShowList(!showList);
  };

  const name = `${firstName} ${otherName} ${lastName}`;
  const displayName = `${firstName} ${lastName}`;

  return (
    <div style={container}>
      <div style={headingContainer}>
        <p style={heading} onClick={handleShowList}>
          {displayName}
        </p>

        <div style={flex}>
          <p
            onClick={() => handleEditDoc(id)}
            // onClick={showProfile}
            style={{
              color: "#fff",
              boxShadow: "0 0 2px 3px #ccc",
              padding: ".25rem 1rem",
              backgroundColor: "goldenrod",
              borderRadius: ".15rem ",
            }}
          >
            Edit
          </p>
          <p
            onClick={() => handleDeleteDoc(id)}
            style={{
              boxShadow: "0 0 2px 3px #ccc",
              padding: ".25rem",
              backgroundColor: "red",
              borderRadius: ".15rem ",
              margin: "0 .35rem",
              color: "#f3f3f3",
            }}
          >
            Delete
          </p>
          <p
            onClick={() => handleShowProfile(id)}
            style={{
              padding: ".25rem",
              boxShadow: "0 0 2px 3px #ccc",
              backgroundColor: "var(--success)",
              color: "#f3f3f3",
              borderRadius: ".15rem ",
            }}
          >
            Profile
          </p>
        </div>
      </div>
      <div style={showList ? { display: "block" } : { display: "none" }}>
        <div style={listControl}>
          <h4>Name</h4>
          <p>{name}</p>
        </div>

        <div style={listControl}>
          <h4>Date of Birth</h4>
          <p>{age}</p>
        </div>

        <div style={listControl}>
          <h4>Class</h4>
          <p>{selectClass}</p>
        </div>

        <div style={listControl}>
          <h4>Email</h4>
          <p>{email}</p>
        </div>

        <div style={listControl_Image}>
          <h4>Selected Image</h4>
          <img style={image} src={url} alt="" />
        </div>
      </div>
    </div>
  );
};

const container = {
  //   backgroundColor: "var(--secondary)",
  marginTop: "0.5rem",
  border: "1px solid #ccc",
  borderRadius: "0.25rem",
};

const headingContainer = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "0.5rem 0.5rem",
  borderRadius: "0.25rem",
  boxShadow: "0 0 1px 1px #ccc",
  borderTop: "3px solid var(--success)",
  backgroundColor: "#ededed",
};

const flex = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

const heading = {
  flex: 1,
  color: "#333",
  fontSize: "0.75rem",
  fontWeight: "600",
};

const listControl = {
  display: "flex",
  flexDirection: "column",
  marginBottom: "0.25rem",
  padding: "0.5rem 0.5rem",
  backgroundColor: "var(--light)",
  // borderBottom: "1px solid #aaa",
};

const listControl_Image = {
  display: "flex",
  flexDirection: "column",
  marginBottom: "0.25rem",
  padding: "0.5rem 0.5rem",
  backgroundColor: "var(--light)",
  borderBottom: "2px solid #aaa",
  maxWidth: "600px",
  width: "100%",
  height: "300px",
};

const image = {
  objectFit: "cover",
  objectPosition: "center",
  height: "90%",
};

export default UpdatedStudent;
